import { ReactNode } from "react"
import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    row: {
        padding: ".75rem 0",
        borderBottom: `1px solid ${theme.palette.tailwind.slate[100]}`,
        "&:last-child": { borderBottom: "none" },
    },
    label: {
        fontWeight: theme.typography.fontWeightMedium,
        color: theme.palette.tailwind.slate[500],
    },
    value: {
        fontWeight: theme.typography.fontWeightBold,
        color: theme.palette.tailwind.slate[800],
        textAlign: "right",
    },
}))

type DrawerDetailRowProps = Readonly<{
    label: ReactNode
    value: ReactNode
    isElement?: boolean
}>

export function DrawerDetailRow({ label, value, isElement = false }: DrawerDetailRowProps) {
    const { classes } = useStyles()

    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing="1rem"
            className={classes.row}
        >
            <Typography component="span" variant="body2" className={classes.label}>
                {label}
            </Typography>
            {isElement ? (
                value
            ) : (
                <Typography component="span" variant="body2" className={classes.value}>
                    {value}
                </Typography>
            )}
        </Stack>
    )
}
